/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';
import { Modal, Form } from 'react-bootstrap';
import { Label as BootstrapLabel } from 'reactstrap';
import { ReactComponent as AcceptIc } from '~/assets/icons/accept.svg';
import { ReactComponent as CancelIc } from '~/assets/icons/cancel.svg';

export const AcceptIcon = styled(AcceptIc)`
  &:hover {
    cursor: pointer;
  }
`;

export const CancelIcon = styled(CancelIc)`
  &:hover {
    cursor: pointer;
  }
`;

export const Container = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  padding: 30px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Question = styled.span`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.purple};
  @media (max-width: 375px) {
    font-size: 1.4375rem;
  }
`;

export const BackButton = styled.span`
  font-size: 1.25rem;
  color: #074f8c;
  margin-right: 10px;
  cursor: pointer;
  @media (max-width: 375px) {
    font-size: 1.125rem;
  }
`;

export const CloseIcon = styled.span`
  font-size: 1.8rem;
  color: #074f8c;
  cursor: pointer;
  @media (max-width: 370px) {
    font-size: 1.125rem;
  }
`;

export const Title = styled.span`
  font-size: 1.125rem;
  font-weight: 400;
  color: #808495;
  @media (max-width: 385px) {
    font-size: 0.875rem;
  }
`;

export const Buttons = styled.div`
  width: 100%;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100% !important;
  margin-top: 25px !important;
`;

export const Button = styled.div`
  width: 100%;
  height: 50px;
  margin-left: -30px;
  margin-bottom: -30px;
  margin-top: 33px;
  border-bottom-left-radius: 20px;
  background-color: #000000;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const ButtonYes = styled.div`
  width: 100%;
  max-width: 130px;
  height: 40px;
  margin-left: 20px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.lightGreen};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    color: ${({ theme }) => theme.colors.mediumPurple};
  }
`;

export const ButtonNo = styled.div`
  width: 100%;
  max-width: 130px;
  height: 40px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.mediumPurple};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media (max-width: 400px) {
    width: 100%;
  }

  span {
    color: #ffffff;
  }
`;

export const ButtonConfirmation = styled.button`
  width: 100%;
  height: 50px;
  margin-top: 17px;
  background-color: ${(props) => props.theme.colors.purple};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -50px;
`;

export const SuccessIconContainer = styled.div`
  width: 73px;
  height: 73px;
  border-radius: 36.5px;
  background-color: #e5ffe8;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SuccessIcon = styled.span`
  font-size: 3.4375rem;
  margin-top: 5.5px;
  color: #75b943;
`;

export const SuccessTitle = styled.span`
  font-size: 1.5625rem;
  text-align: center;
  color: #074f8c;
  margin-top: 20px;
  @media (max-width: 370px) {
    font-size: 1.4375rem;
  }
`;

export const SuccessText = styled.span`
  color: #808495;
  text-align: center;
  margin-top: 15px;
  font-size: 1rem;
  padding: 0px 30px 0px 30px;
  @media (max-width: 370px) {
    font-size: 0.9375rem;
    padding: 0;
  }
`;

export const SuccessProtocol = styled.span`
  color: #f0b01b;
  text-align: center;
  margin-top: 15px;
  font-size: 1rem;
  @media (max-width: 370px) {
    font-size: 0.9375rem;
  }
`;

export const ErrorIconContainer = styled.div`
  width: 73px;
  height: 73px;
  border-radius: 36.5px;
  background-color: #fff4e5;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ErrorIcon = styled.span`
  font-size: 3.4375rem;
  margin-top: 5.5px;
  color: #fdc43c;
`;

export const ButtonTitle = styled.span`
  margin-left: 10px;
  font-size: 16px;
`;

export const Icon = styled.span`
  font-size: 1.6875rem;
  color: #ffffff;
  margin-right: 5px;
`;

export const FormContainer = styled(Form)`
  padding-left: 3px;
  padding-right: 3px;
  margin-top: 20px;
`;

export const Label = styled(BootstrapLabel)`
  color: #074f8c;
  font-weight: bold;
  font-size: 1.125rem;
  display: block;
  margin-bottom: 0.3rem;
  font-size: 1rem;
`;

export const Option = styled.option``;

export const FieldName = styled.span`
  color: ${(props) =>
    props.range ? '#3E3E3E' : `${({ theme }) => theme.colors.mediumGray}`};
  margin-bottom: ${(props) => (props.range ? '10px' : '')};
  transition: font-size 1s;
  transform: translateY(-3px);
  font-size: 0.625rem;

  &:hover {
    cursor: pointer;
  }
`;

export const Input = styled.div`
  position: relative;
  display: flex;
  background: ${(props) => (props.range ? 'transparent' : 'white')};
  border-radius: 5px;
  width: 100%;
  color: ${({ theme }) => theme.colors.gray};
  padding: 8px 12px 8px 12px;
  height: 50px;
  flex-direction: column;
  border: ${(props) => (props.range ? 'none' : `1px solid #C1C1C1`)};

  @media (max-width: 1175px) {
    max-width: 100%;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const Select = styled.select`
  position: absolute;
  display: flex;
  width: 93%;
  height: 40px;
  flex: 1;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.gray};
  outline: none !important;
  padding: 0;
  font-size: 12px;

  &::placeholder {
    color: #666360;
  }

  &:hover {
    cursor: pointer;
  }
`;
